var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Money from './Money';
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
var MoneyStore = /** @class */ (function () {
    function MoneyStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.read = function (id) {
            _this.loaded = false;
            if (id) {
                return api.get("moneys/".concat(id)).then(function (item) {
                    _this.item = item;
                    _this.loaded = true;
                    return item;
                });
            }
            return api.get("moneys").then(_this.set);
        };
        this.set = function (data) {
            _this.loaded = true;
            _this.data = data.map(function (value) { return new Money(value); });
            return _this.data;
        };
        this.push = function (data) {
            _this.loaded = true;
            _this.data.push(new Money(data));
            return _this.data;
        };
        this.replace = function (data) {
            _this.loaded = true;
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === data.id; }), 1, data);
        };
        this.pull = function (value) {
            _this.loaded = true;
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
        this.getPrimaryMoney = function () {
            return (_this.data.find(function (money) { return money.primary; }) || _this.data.find(function (money) { return money.alphabeticCode === 'EUR'; }));
        };
        this.getWebMoney = function () {
            return (_this.data.find(function (money) { return money.web; }) || _this.data.find(function (money) { return money.alphabeticCode === 'EUR'; }));
        };
    }
    MoneyStore.prototype.create = function (data) {
        this.loaded = false;
        return api.post('moneys', data).then(this.push);
    };
    MoneyStore.prototype.update = function (id, data) {
        return api.put("moneys/".concat(id), data)
            .then(this.replace);
    };
    MoneyStore.prototype.disable = function (id, disabled) {
        return api.patch("moneys/".concat(id), { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], MoneyStore.prototype, "data", void 0);
    __decorate([
        observable
    ], MoneyStore.prototype, "item", void 0);
    __decorate([
        observable
    ], MoneyStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], MoneyStore.prototype, "read", void 0);
    __decorate([
        action
    ], MoneyStore.prototype, "set", void 0);
    __decorate([
        action
    ], MoneyStore.prototype, "push", void 0);
    __decorate([
        action
    ], MoneyStore.prototype, "replace", void 0);
    __decorate([
        action
    ], MoneyStore.prototype, "pull", void 0);
    return MoneyStore;
}());
export default MoneyStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/MoneyStore.ts
// module id = 742
// module chunks = 0